import React, { forwardRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import th from "date-fns/locale/th"; // the locale you want
 // register it with the name you want
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Button from '@material-ui/core/Button'

import "react-datepicker/dist/react-datepicker.css";
registerLocale("th", th);
// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

const DateTime = (props) => {
  // console.log(props)
  // const [startDate, setStartDate] = useState(new Date());
  // const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [startDate, endDate] = props.DateNow;
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (

    <Button aria-label="delete" size="small" onClick={onClick} ref={ref}>
      {value}<KeyboardArrowDownIcon fontSize="inherit" />
    </Button >
  ));
  // console.log(moment().format())
  // console.log(dateRange)
  return (
    <>
      <DatePicker
        selectsRange={true}
        startDate={startDate}
        endDate={endDate}
        locale="th"
        dateFormat="eeee d MMMM, yyyy"
        onChange={(update) => {
          props.setDateRange(update);
        }}
        // isClearable={true}
        customInput={<ExampleCustomInput />}
      />

    </>
  );
};
export default DateTime;